import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { sciFormatted } from '../../../utils/formatting';
import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
};

const padding20 = {
  padding: 20,
  height: 150,
};

const AvgViews = props => {
  const { profile } = props;
  const rawInstagramPosts = _.get(profile, 'rawInstagramPosts', []);
  // const adPosts = _.filter(rawInstagramPosts, ({ isAd: true }));
  const postsWithViews = _.filter(rawInstagramPosts, post => post.viewCount > 0);
  console.log(postsWithViews);
  const totalViews = _.sumBy(postsWithViews, 'viewCount');
  console.log(totalViews);
  return (
    <div style={padding20}>
      <h2 style={leftAlign}>{_.isEmpty(postsWithViews) ? '-' : sciFormatted(totalViews / _.size(postsWithViews))}</h2>
      <BlockLabel label="Avg Views" />
    </div>
  );
};

AvgViews.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default AvgViews;



// WEBPACK FOOTER //
// ./src/containers/summary/components/avg-views.js